

$(".navbar-toggler").click(function(){

  $(".navbar-toggler").toggleClass("showtoggle");
  $('body').toggleClass("showbody");

});



$(".closed").click(function(){

  $(".navbar-collapse").removeClass("show");

});   


    $(".jobsbtn a").click(function(){
        $(".topjobbox").slideToggle("slow");
    });


    $(".searh_bx a").click(function(){
        $(".topjobbox").slideToggle("slow");
    });


$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
        $(".header_sec").addClass("fixed");

    } else {
        $(".header_sec").removeClass("fixed");
    }
    
});


jQuery(document).ready(function($) {

    $('.latest-position-carousel').owlCarousel({

        loop: true,

        margin: 0,

        nav: false,

        dots: true,

        autoplay: false,

        smartSpeed: 600,

        responsive: {

            0: {
                items: 1
            },

            768: {
                items: 2
            },

            1200: {
                items: 3
            }

        }

    });

});

jQuery(document).ready(function($) {

    $(".fancybox").fancybox({
        padding: 0,
        margin: 30,

        openEffect: 'fade',
        closeEffect: 'fade',

        nextEffect: 'fade',
        prevEffect: 'fade',

        helpers: {
            title: {
                type: 'inside'
            },
            overlay: {
                css: {
                    'background': 'rgba(0,0,0,0.85)'
                }
            }
        }
    });

});


jQuery(document).ready(function($) {

    $('.candidate-testimonial-carousel').owlCarousel({

        loop: true,

        margin: 0,

        nav: false,

        dots: true,

        autoplay: true,

        autoplayTimeout: 5000,

        autoplayHoverPause: true,

        smartSpeed: 600,

        responsive: {

            0: {
                items: 1
            },

            768: {
                items: 2
            },

            992: {
                items: 3
            }

        }

    });

});

jQuery(document).ready(function($) {

    var $carousel = $('.company-logo-carousel');

    $carousel.owlCarousel({

        loop: true,

        margin: 0,

        nav: false,

        dots: false,

        autoplay: true,

        //autoplayTimeout: 0,

        autoplayHoverPause: false,

        //smartSpeed: 8000,

        //slideTransition: 'linear',

        responsive: {

            0: {
                items: 3
            },

            576: {
                items: 4
            },

            768: {
                items: 5
            },

            992: {
                items: 7
            },

            1200: {
                items: 8
            }

        }

    });

});

jQuery(function($) {

    $('.footer-menu-column h4').on('click', function() {

        var $currentColumn = $(this).closest('.footer-menu-column');
        var $currentMenu   = $currentColumn.children('ul');

        /* Close sibling menus */
        $currentColumn
            .siblings('.footer-menu-column')
            .removeClass('active')
            //.children('ul')
            //.stop(true, true)
           // .slideUp(300);

        /* Toggle clicked menu */
        $currentColumn.toggleClass('active');

        $currentMenu
            //.stop(true, true)
            //.slideToggle(300);

    });

});
$(document).ready(function () {

    $('.select_field select').each(function () {

        var select = $(this);
        var wrapper = select.closest('.select_field');

        // Create custom select
        var customSelect = $('<div class="custom-select"></div>');

        // Button
        var button = $('<button type="button" class="custom-select-btn"></button>');

        button.append(
            '<span class="custom-select-text">' +
            select.find('option:selected').text() +
            '</span>'
        );

        button.append('<span class="custom-select-arrow"></span>');

        // Dropdown list
        var list = $('<div class="custom-select-list"></div>');

        // Create options from original select
        select.find('option').each(function (index) {

            var option = $(this);

            // Skip placeholder
            if (option.val() === '') {
                return;
            }

            var customOption = $('<div class="custom-select-option"></div>');

            customOption.attr('data-value', option.val());

            customOption.append(
                '<span class="custom-select-check"></span>'
            );

            customOption.append(
                '<span class="custom-select-option-text">' +
                option.text() +
                '</span>'
            );

            list.append(customOption);
        });

        customSelect.append(button);
        customSelect.append(list);

        // Add custom dropdown after select
        wrapper.append(customSelect);

        // Open / close
        button.on('click', function (e) {

            e.preventDefault();

            $('.custom-select').not(customSelect).removeClass('active');

            customSelect.toggleClass('active');

        });

        // Select option
        list.on('click', '.custom-select-option', function () {

            var option = $(this);
            var value = option.data('value');
            var text = option.find('.custom-select-option-text').text();

            // Update original select
            select.val(value).trigger('change');

            // Update button text
            customSelect.find('.custom-select-text').text(text);

            // Selected class
            list.find('.custom-select-option').removeClass('selected');
            option.addClass('selected');

            // Close
            customSelect.removeClass('active');

        });

        // Set selected option if already selected
        var selectedValue = select.val();

        if (selectedValue) {

            list.find('.custom-select-option').each(function () {

                if ($(this).data('value') == selectedValue) {
                    $(this).addClass('selected');

                    customSelect.find('.custom-select-text').text(
                        $(this).find('.custom-select-option-text').text()
                    );
                }

            });

        }

    });


    // Close when clicking outside
    $(document).on('click', function (e) {

        if (!$(e.target).closest('.custom-select').length) {
            $('.custom-select').removeClass('active');
        }

    });

});